import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { IProjectCheckpointCriterion } from '../../projectCheckpoints.types'
import NumberInput from 'shared/Inputs/NumberInput'
import Textarea from 'shared/Inputs/Textarea'
import { PropsWithChildren } from 'react'

interface IProps {
  criteria: Omit<IProjectCheckpointCriterion, 'id'>
  onChange: (val: any, name: string) => void
}

const CriteriaSheet = (props: PropsWithChildren<IProps>) => {
  return (
    <Sheet>
      <div className='flex-lines'>
        <TextField header='Название критерия'>
          <TextInput value={props.criteria.title} onChange={props.onChange} name='title' placeholder='Критерий 1' />
        </TextField>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1em', justifyContent: 'space-between' }}>
          <TextField header='Баллы: мин.' style={{ flex: 0.5 }}>
            <NumberInput value={props.criteria.minBalls} onChange={props.onChange} name='minBalls' />
          </TextField>
          <TextField header='макс.' style={{ flex: 0.5 }}>
            <NumberInput value={props.criteria.maxBalls} onChange={props.onChange} name='maxBalls' />
          </TextField>
        </div>
        <TextField header="Комментарий">
            <Textarea
              value={props.criteria.description}
              onChange={props.onChange}
              name='description'
              placeholder='Описание критерия для проверяющего'
              required={false}
            />
          </TextField>
      </div>
      <div>{props.children}</div>
    </Sheet>
  )
}

export default CriteriaSheet
